<template>
  <div>
    <div id="customer-profile-details" class="vx-row">
      <vx-card title="LIST OF SETTINGS">

        <div class="vx-col w-full">
          <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(updateSettings)">
              <div class="vx-row mb-3 mt-4">
                <div class="vx-col w-full">
                  <ValidationProvider name="company_name" rules="required" v-slot="{ errors }" vid="company_name">
                    <small class="label">Company Name</small>
                    <vs-input class="w-full" name="company_name" type="text" v-model="createForm.company_name"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <!-- <div class="vx-row mb-3 mt-4">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider name="town" rules="required" v-slot="{ errors }" vid="town">
                  <small class="label">Address Line 1</small>
                  <vs-input class="w-full" name="address_line_1" type="text" v-model="createForm.address_line_1"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <small class="label">Address Line 2</small>
                  <vs-input class="w-full" name="address_line_2" type="text" v-model="createForm.address_line_2"/>
                </div>
              </div> -->
              <!-- <div class="vx-row mb-3 mt-4">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <small class="label">Address Line 3</small>
                  <vs-input class="w-full" name="address_line_3" type="text" v-model="createForm.address_line_3"/>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider name="town" rules="required" v-slot="{ errors }" vid="town">
                    <small class="label">Town</small>
                    <vs-input class="w-full" name="town" v-model="createForm.town"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div> -->
              <!-- <div class="vx-row mb-3 mt-4">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider name="post_code" rules="required" v-slot="{ errors }" vid="post_code">
                    <small class="label">Post Code</small>
                    <vs-input class="w-full" name="post_code" type="text" v-model="createForm.post_code"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider name="country" rules="required" v-slot="{ errors }" vid="country">
                    <small class="label">Country</small>
                    <vs-input class="w-full" name="country" type="text" v-model="createForm.country"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div> -->
              <div class="vx-row mb-3 mt-4">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider name="telephone" rules="" v-slot="{ errors }" vid="telephone">
                    <small class="label">Telephone</small>
                    <vs-input class="w-full" name="telephone" type="text" v-model="createForm.telephone"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <small class="label">Website</small>
                  <vs-input class="w-full" name="website" type="text" v-model="createForm.website"/>
                </div>
              </div>
              <div class="vx-row mb-3 mt-4">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider name="vat_no" rules="" v-slot="{ errors }" vid="vat_no">
                    <small class="label">VAT No</small>
                    <vs-input class="w-full" name="vat_no" type="text" v-model="createForm.vat_no"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider name="company_no" rules="" v-slot="{ errors }" vid="company_no">
                    <small class="label">Company No</small>
                    <vs-input class="w-full" name="company_no" type="text" v-model="createForm.company_no"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-row mb-3 mt-4">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider name="eori_eu" rules="" v-slot="{ errors }" vid="eori_eu">
                    <small class="label">EORI for EU</small>
                    <vs-input class="w-full" name="eori_eu" type="text" v-model="createForm.eori_eu"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider name="eori_ni" rules="" v-slot="{ errors }" vid="eori_ni">
                    <small class="label">EORI for NI</small>
                    <vs-input class="w-full" name="eori_ni" type="text" v-model="createForm.eori_ni"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-row mb-3 mt-4">
            <div class="vx-col md:w-1/2 w-full">
              <small class="label">Financial Year Start Month</small>
              <v-select v-model="createForm.financial_year_start_month"
                        :options="[
                          'January', 'February', 'March', 'April', 'May', 'June', 'July',
                          'August', 'September', 'October', 'November', 'December'
                          ]"/>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <small class="label">System Language</small>
              <v-select v-model="createForm.system_language"
                        :options="['en']"/>
            </div>
            </div>
            <div class="vx-row mb-3 mt-4">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider name="bespoke_price_check_days" rules="" v-slot="{ errors }" vid="bespoke_price_check_days">
                <small class="label">Bespoke Price Check (Days)</small>
                <vs-input class="w-full" name="bespoke_price_check_days" type="text" v-model="createForm.bespoke_price_check_days"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider name="create_work_order_when_not_in_stock" rules="required" v-slot="{ errors }" vid="create_work_order_when_not_in_stock">
              <small class="label">Do you want to create Work Orders when ingredients are not in stock?</small>
                <v-select v-model="createForm.create_work_order_when_not_in_stock" label="name" :reduce="option => option.value"
                          :options="[{ name: 'Yes', value: true }, { name: 'No', value: false }]"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

              <div>
                <h5 class="mb-4 mt-16">Sales Contact</h5>
                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <small class="label">Sales contact telephone</small>
                    <vs-input class="w-full" name="sales_contact_tel" type="text" v-model="createForm.sales_contact_tel"/>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <small class="label">Sales contact email</small>
                    <vs-input class="w-full" name="sales_contact_email" type="email" v-model="createForm.sales_contact_email"/>
                  </div>
                </div>
                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <small class="label">Technical Contact Email</small>
                    <vs-input class="w-full" name="technical_contact_email" type="text" v-model="createForm.technical_contact_email"/>
                  </div>
                </div>
              </div>

              <div>
                <h5 class="mb-4 mt-16">Working Hours</h5>
                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <small class="label">From</small>
                    <vs-input class="w-full" name="working_hour_from" type="text" v-model="createForm.working_hour_from"/>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <small class="label">To</small>
                    <vs-input class="w-full" name="working_hour_to" type="text" v-model="createForm.working_hour_to"/>
                  </div>
                </div>
              </div>

              <div>
                <h5 class="mb-4 mt-16">Delivery Days</h5>
                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full">
                    <ValidationProvider name="product_delivery_days_uk" rules="required" v-slot="{ errors }"
                                        vid="product_delivery_days_uk">
                      <small class="label">Product Delivery Days UK(Business Days)</small>
                      <vs-input class="w-full" name="product_delivery_days_uk" type="number"
                                v-model="createForm.product_delivery_days_uk"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full">
                    <ValidationProvider name="product_delivery_days_eu" rules="required" v-slot="{ errors }"
                                        vid="product_delivery_days_eu">
                      <small class="label">Product Delivery Days EU(Business Days)</small>
                      <vs-input class="w-full" name="product_delivery_days_eu" type="number"
                                v-model="createForm.product_delivery_days_eu"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full">
                    <ValidationProvider name="product_delivery_days_row" rules="required" v-slot="{ errors }"
                                        vid="product_delivery_days_row">
                      <small class="label">Product Delivery Days row(Business Days)</small>
                      <vs-input class="w-full" name="product_delivery_days_row" type="number"
                                v-model="createForm.product_delivery_days_row"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
              </div>

              <div>
                <h5 class="mb-4 mt-16">Shelf Location</h5>
                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/6 w-full md:mb-0">
                    <small class="label">Shelf Location <span class="font-bold text-md">R</span></small>
                    <vx-input-group>
                      <template slot="prepend">
                        <div class="prepend-text bg-primary">
                          <span>from</span>
                        </div>
                      </template>
                      <vs-input class="w-full" name="working_hour_from" type="text"
                                v-model="createForm.shelf_location_r_from"/>
                    </vx-input-group>
                  </div>
                  <div class="vx-col md:w-1/6 w-full md:mb-0">
                    <small class="label">&nbsp;</small>
                    <vx-input-group>
                      <template slot="prepend">
                        <div class="prepend-text bg-primary">
                          <span>to</span>
                        </div>
                      </template>
                      <vs-input class="w-full" name="working_hour_to" type="text" v-model="createForm.shelf_location_r_to"/>
                    </vx-input-group>
                  </div>
                  <div class="vx-col md:w-1/6 w-full md:mb-0">
                    <small class="label">Shelf Location <span class="font-bold text-md">S</span></small>
                    <vx-input-group>
                      <template slot="prepend">
                        <div class="prepend-text bg-primary">
                          <span>from</span>
                        </div>
                      </template>
                      <vs-input class="w-full" name="working_hour_from" type="text"
                                v-model="createForm.shelf_location_s_from"/>
                    </vx-input-group>
                  </div>
                  <div class="vx-col md:w-1/6 w-full md:mb-0">
                    <small class="label">&nbsp;</small>
                    <vx-input-group>
                      <template slot="prepend">
                        <div class="prepend-text bg-primary">
                          <span>to</span>
                        </div>
                      </template>
                      <vs-input class="w-full" name="working_hour_to" type="text" v-model="createForm.shelf_location_s_to"/>
                    </vx-input-group>
                  </div>
                  <div class="vx-col md:w-1/6 w-full md:mb-0">
                    <small class="label">Shelf Location <span class="font-bold text-md">L</span></small>
                    <vx-input-group>
                      <template slot="prepend">
                        <div class="prepend-text bg-primary">
                          <span>from</span>
                        </div>
                      </template>
                      <vs-input class="w-full" name="working_hour_from" type="text"
                                v-model="createForm.shelf_location_l_from"/>
                    </vx-input-group>
                  </div>
                  <div class="vx-col md:w-1/6 w-full md:mb-0">
                    <small class="label">&nbsp;</small>
                    <vx-input-group>
                      <template slot="prepend">
                        <div class="prepend-text bg-primary">
                          <span>to</span>
                        </div>
                      </template>
                      <vs-input class="w-full" name="working_hour_to" type="text" v-model="createForm.shelf_location_l_to"/>
                    </vx-input-group>
                  </div>
                </div>
              </div>

              <div class="vx-row mb-3 mt-16">
                <div class="vx-col md:w-1/2 w-full">
                  <ValidationProvider name="mlor_threshold" rules="" v-slot="{ errors }"
                                      vid="mlor_threshold">
                    <small class="label">MLOR threshold (%)</small>
                    <vs-input class="w-full" name="mlor_threshold" type="text"
                              v-model="createForm.mlor_threshold"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <ValidationProvider name="standard_credit_terms" rules="" v-slot="{ errors }"
                                      vid="standard_credit_terms">
                    <small class="label">Standard Credit Terms (days)</small>
                    <vs-input class="w-full" name="standard_credit_terms" type="number"
                              v-model="createForm.standard_credit_terms"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <h5 class="mb-4 mt-16">Formulation</h5>
              <div class="vx-row mb-3 mt-4">
                <div class="vx-col md:w-1/2 w-full">
                  <ValidationProvider vid="gross_margin" name="gross_margin" rules="required" v-slot="{ errors }">
                    <small class="label">Gross margin (%)</small>
                    <vs-input v-model="createForm.gross_margin" class="w-full"  name="gross_margin" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <ValidationProvider vid="machine_cost_per_hour" name="machine_cost_per_hour" rules="required" v-slot="{ errors }">
                    <small class="label">Machine cost per hour (GBP)</small>
                    <vs-input v-model="createForm.machine_cost_per_hour" class="w-full"  name="machine_cost_per_hour" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col md:w-1/2 w-full">
                  <ValidationProvider vid="labour_cost_per_hour" name="labour_cost_per_hour" rules="required" v-slot="{ errors }">
                    <small class="label">Labour cost per hour (GBP)</small>
                    <vs-input v-model="createForm.labour_cost_per_hour" class="w-full"  name="labour_cost_per_hour" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <ValidationProvider name="formulation_expiration_months" rules="required" v-slot="{ errors }"
                                      vid="formulation_expiration_months">
                    <small class="label">Formulation Expiration Months</small>
                    <vs-input class="w-full" name="formulation_expiration_months" type="number"
                              v-model="createForm.formulation_expiration_months"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider vid="sundry_cost_per_kg_liquid" name="sundry_cost_per_kg_liquid" rules="" v-slot="{ errors }">
                <small class="label">Liquid Sundry Cost Per Kg</small>
                <vs-input v-model="createForm.sundry_cost_per_kg_liquid" class="w-full"  name="sundry_cost_per_kg_liquid" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider vid="sundry_cost_per_kg_powder" name="sundry_cost_per_kg_powder" rules="" v-slot="{ errors }">
                <small class="label">Powder Sundry Cost Per Kg</small>
                <vs-input v-model="createForm.sundry_cost_per_kg_powder" class="w-full"  name="sundry_cost_per_kg_powder" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider vid="work_order_variance_percent" name="work_order_variance_percent" rules="" v-slot="{ errors }">
                <small class="label">Manufacturing Variance (increase to plan by %)</small>
                <vs-input v-model="createForm.work_order_variance_percent" class="w-full"  name="work_order_variance_percent" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider name="default_formulation_clean_hours" rules="required" v-slot="{ errors }" vid="default_formulation_clean_hours">
                <small class="label">Default Formulation Clean Hours</small>
                <flat-pickr :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}"
                            class="w-full" v-model="createForm.default_formulation_clean_hours"
                            placeholder="H:m"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider name="default_formulation_labour_hours" rules="required" v-slot="{ errors }" vid="default_formulation_labour_hours">
                <small class="label">Default Formulation Labour Hours</small>
                <flat-pickr :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}"
                            class="w-full" v-model="createForm.default_formulation_labour_hours"
                            placeholder="H:m"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider name="default_formulation_machine_hours" rules="required" v-slot="{ errors }" vid="default_formulation_machine_hours">
                <small class="label">Default Formulation Machine Hours</small>
                <flat-pickr :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}"
                            class="w-full" v-model="createForm.default_formulation_machine_hours"
                            placeholder="H:m"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <h5 class="mb-4 mt-16">Forecast Tool</h5>
          <div class="vx-row mb-8 mt-4">
            <div class="vx-col md:w-1/2 w-full">
                <small class="label">Time Interval</small>
                <v-select :disabled="createForm.sales_marketing_tool_time_interval.length > 0"
                  v-model="createForm.sales_marketing_tool_time_interval" :options="['daily','weekly','monthly']"/>
              <small v-if="createForm.sales_marketing_tool_time_interval.length > 0"
                     class="text-danger">* You cannot change the forecast interval without contacting the administrator.
              </small>
            </div>
            <div class="vx-col md:w-1/2 w-full">
                <small class="label">Unit</small>
                <v-select v-model="createForm.sales_marketing_tool_unit" :options="['Kg','g']"/>
            </div>
          </div>
          <h5 class="mb-4 mt-16">Orders</h5>
          <div class="vx-row mb-8 mt-4">
          <div class="vx-col md:w-full w-full">
            <small class="label">Order Special Instructions</small>
            <vs-textarea class="mb-0" v-model="createForm.order_delivery_instructions" height="100px"/>
          </div>
          </div>

              <div class="flex flex-wrap items-center justify-end">
                <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
              </div>
            </form>
          </ValidationObserver>

        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import {RepositoryFactory} from "@/repository/RepositoryFactory";
import myUpload from 'vue-image-crop-upload/upload-2.vue';
import Cookies from "js-cookie";
import moment from "moment";
import SuccessMessage from "@/mixins/SuccessMessage";
import ErrorMessages from "@/mixins/ErrorMessages";
import SettingRepository from "@/repository/SettingRepository";
const settingsRepository =  RepositoryFactory.get('settings')
const FileRepository = RepositoryFactory.get('file')
import vSelect from "vue-select";
import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'

export default {
  name: "TenantSettingsView",
  async mounted() {
    this.tenantId = this.$route.params.id
    await this.fetchSettings()
  },
  components: {
    'my-upload': myUpload,
    'v-select':vSelect,
    flatPickr,
  },
  mixins: [SuccessMessage, ErrorMessages],
  data () {
    return {
      settings:{},
      createForm:{
        company_name: '',
          address_line_1: '',
          address_line_2: '',
          address_line_3: '',
          town: '',
          post_code: '',
          country: '',
          telephone: '',
          website: '',
          vat_no: '',
          company_no: '',
          eori_ni: '',
          eori_eu: '',
          working_hour_from: '',
          working_hour_to: '',
          product_delivery_days_uk: '',
          product_delivery_days_eu: '',
          product_delivery_days_row: '',
          formulation_expiration_months: '',
          shelf_location_r_from: '',
          shelf_location_r_to: '',
          shelf_location_s_from: '',
          shelf_location_s_to: '',
          shelf_location_l_from: '',
          shelf_location_l_to: '',
          mlor_threshold: '',
          standard_credit_terms: '',
          sales_contact_tel: '',
          sales_contact_email: '',
          technical_contact_email: '',
          labour_cost_per_hour: '',
          machine_cost_per_hour: '',
          gross_margin: '',
          forecast_tool_time_interval: '',
          forecast_tool_unit: '',
          financial_year_start_month: '',
          order_delivery_instructions:'',
          work_order_variance_percent: '',
          sundry_cost_per_kg_liquid: '',
          sundry_cost_per_kg_powder: '',
          system_language:'',
          default_formulation_clean_hours: '',
          default_formulation_labour_hours: '',
          default_formulation_machine_hours: '',
          bespoke_price_check_days: '',
          sales_marketing_tool_time_interval: ''
      },
      avatar:'',
      show:false,
      params: {
        token: Cookies.get('current_user_token'),
        name: 'avatar'
      },
      headers: {
        authorization: 'Bearer ' + Cookies.get('current_user_token'),
      },
      tenantId:null,
    }
  },
  methods: {
    async fetchSettings(){
      this.$vs.loading();
      try {
        const {data} = (await settingsRepository.getSettingsList(this.tenantId)).data

const keys = Object.keys(data);
    for (const key of keys) {
      data[key].elements.forEach((x) => {
        this.createForm[x.name] = x.value ? x.value : ''
      })
    }

    this.createForm.working_hour_from = this.__utcToLocalTime(data.working_hours.elements[0].value);
    this.createForm.working_hour_to = this.__utcToLocalTime(data.working_hours.elements[1].value);
    this.createForm.company_logo = this.company_logo

// this.createForm.company_name = data.company_name.elements[0].value;
// this.createForm.address_line_1 = data.address_line_1.elements[0].value;
// this.createForm.address_line_2 = data.address_line_2.elements[0].value;
// this.createForm.address_line_3 = data.address_line_3.elements[0].value;
// this.createForm.town = data.town.elements[0].value;
// this.createForm.post_code = data.post_code.elements[0].value;
// this.createForm.country = data.country.elements[0].value;
// this.createForm.telephone = data.telephone.elements[0].value;
// this.createForm.website = data.website.elements[0].value;

// this.createForm.vat_no = data.vat_no.elements[0].value;
// this.createForm.company_no = data.company_no.elements[0].value;
// this.createForm.eori_ni = data.eori_ni.elements[0].value;
// this.createForm.eori_eu = data.eori_eu.elements[0].value;

// this.createForm.mlor_threshold = data.mlor_threshold.elements[0].value;
// this.createForm.working_hour_from = this.__utcToLocalTime(data.working_hours.elements[0].value);
// this.createForm.working_hour_to = this.__utcToLocalTime(data.working_hours.elements[1].value);

// this.createForm.product_delivery_days_uk = data.product_delivery_days_uk.elements[0].value;
// this.createForm.product_delivery_days_eu = data.product_delivery_days_eu.elements[0].value;
// this.createForm.product_delivery_days_row = data.product_delivery_days_row.elements[0].value;

// this.createForm.formulation_expiration_months = data.formulation_expiration_months.elements[0].value;

// this.createForm.shelf_location_r_from = data.shelf_location_r.elements[0].value;
// this.createForm.shelf_location_r_to = data.shelf_location_r.elements[1].value;

// this.createForm.shelf_location_s_from = data.shelf_location_s.elements[0].value;
// this.createForm.shelf_location_s_to = data.shelf_location_s.elements[1].value;

// this.createForm.shelf_location_l_from = data.shelf_location_l.elements[0].value;
// this.createForm.shelf_location_l_to = data.shelf_location_l.elements[1].value;

// this.createForm.standard_credit_terms = data.standard_credit_terms.elements[0].value;

// this.createForm.sales_contact_tel = data.sales_contact_tel.elements[0].value;
// this.createForm.sales_contact_email = data.sales_contact_email.elements[0].value;
// this.createForm.technical_contact_email = data.technical_contact_email.elements[0].value;

// this.createForm.payment_bank_name = data.payment_bank_name.elements[0].value;
// this.createForm.payment_bank_account_name = data.payment_bank_account_name.elements[0].value;
// this.createForm.payment_bank_account_number = data.payment_bank_account_number.elements[0].value;
// this.createForm.payment_bank_sort_code = data.payment_bank_sort_code.elements[0].value;
// this.createForm.payment_bank_iban = data.payment_bank_iban.elements[0].value;
// this.createForm.payment_bank_swiftbic = data.payment_bank_swiftbic.elements[0].value;

// this.createForm.labour_cost_per_hour = data.labour_cost_per_hour.elements[0].value;
// this.createForm.machine_cost_per_hour = data.machine_cost_per_hour.elements[0].value;
// this.createForm.gross_margin = data.gross_margin.elements[0].value;

// this.createForm.company_logo = data.company_logo.elements[0].value
// this.avatar = data.company_logo.elements[0].value
      } catch (error) {
        console.log(error);
      }
      this.$vs.loading.close()

    },
    async updateSettings() {
      this.$vs.loading();
      try {
        const payload = this.createForm
        payload.working_hour_from = moment(this.createForm.working_hour_from, 'HH:mm').utc().format('HH:mm')
        payload.working_hour_to = moment(this.createForm.working_hour_to, 'HH:mm').utc().format('HH:mm')
        payload.labour_cost_per_hour = Number(this.createForm.labour_cost_per_hour).toFixed(2)
        payload.machine_cost_per_hour = Number(this.createForm.machine_cost_per_hour).toFixed(2)
        payload.gross_margin = Number(this.createForm.gross_margin).toFixed(2)
        payload.sundry_cost_per_kg_liquid = Number(this.createForm.sundry_cost_per_kg_liquid).toFixed(2)
        payload.sundry_cost_per_kg_powder = Number(this.createForm.sundry_cost_per_kg_powder).toFixed(2)
        await settingsRepository.updateSettings(this.tenantId,payload);
        this.showSuccessMessage('Settings Updated Successfully!')
      }catch (error) {
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close()
    }

  }
}
</script>

<style scoped>

</style>
